<template>
  <div class="modal fade delete-service-current-modal" id="DeleteServiceModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar serviço</h1>
                  <button type="button" class="btn-close delete-service-current-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeleteService" v-on:submit="deleteServiceMethod()">
                <div class="modal-body ps-30 pe-30">
                  <p v-if="getCurrentDeleteService">Quer realmente deletar o serviço "{{ getCurrentDeleteService.name }}" ?</p>
                  <p>se precisar deste serviço no futuro, vai precisar criá-lo novamente</p>
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="remote_path" class="form-label fw-medium"
                      >Senha do sistema</label
                    >
                    <input
                      type="password"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="password_service_delete"
                      autocomplete="off"
                      required
                    />
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiDeleteService" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeleteService">
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger delete-service-current-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonDeleteConfigurationUpdateService" class="btn btn-dark">Deletar serviço</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default {
  name: "DeleteServiceModal",
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getCurrentDeleteService'
    ])
  },
  methods: {
    deleteServiceMethod(){
      event.preventDefault();

      if(
        document.getElementById("password_service_delete") == undefined ||
        document.getElementById("password_service_delete").value == ""
      ){
        this.alertResponse("Por favor preencha a senha", true);
        return;
      }

      const password_service_delete = document.getElementById("password_service_delete").value;
      const id_delete = this.getCurrentDeleteService.id;

      const objUserDelete = {
        "id": id_delete,
        "password": password_service_delete
      }

      const buttonDeleteConfigurationUpdateService = this.$refs.buttonDeleteConfigurationUpdateService;
      buttonDeleteConfigurationUpdateService.disabled = true;
      buttonDeleteConfigurationUpdateService.innerHTML = "Deletando...";
      const alertResponse = this.alertResponse;

        api.axios.post("/api/service/delete", objUserDelete).catch(function(error){
          if(error.response.data != undefined){
            buttonDeleteConfigurationUpdateService.innerHTML = "Deletar serviço";
          }
          console.log("error", error);
          alertResponse(error.response.data, true);
        }).then(function(response){
          
          if(response != undefined && response.status == 200){
            buttonDeleteConfigurationUpdateService.innerHTML = "Serviço deletado com sucesso !";
            window.location.reload();
          } else {
            buttonDeleteConfigurationUpdateService.disabled = false;
            buttonDeleteConfigurationUpdateService.innerHTML = "Deletar serviço";
            
            document.getElementById("password_service_delete").value = "";
          }
        });
    },
    alertResponse(message, error){
      const warningMessage = `<i class="flaticon flaticon-warning"></i> `+message;
      const successMessage = `<i class="flaticon flaticon-check"></i> `+message;
      
      if(error){
        document.getElementById("errorMessageDeleteService").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeleteService").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeleteService");
      if(elementAlert){
        if(error){
          
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

      const password = document.getElementById("password_service_delete");
      if(password){
        password.value = "";
      }
    },
  }
};
</script>